const FloorPlan = {
  ONE_ROOM: "ワンルーム",
  K1: "1K",
  DK1: "1DK",
  LDK1: "1LDK",
  SLDK1: "1SLDK",
  K2: "2K",
  DK2: "2DK",
  LDK2: "2LDK",
  SLDK2: "2SLDK",
  K3: "3K",
  DK3: "3DK",
  LDK3: "3LDK",
  SLDK3: "3SLDK",
  K4: "4K",
  DK4: "4DK",
  LDK4: "4LDK",
  SLDK4: "4SLDK",
  K5: "5K",
  DK5: "5DK",
  LDK5: "5LDK",
  SLDK5: "5SLDK",
};

export type IFloorPlan = typeof FloorPlan[keyof typeof FloorPlan];

export const floorPlanOptions = Object.values(FloorPlan).map(value => ({
  label: value === FloorPlan.ONE_ROOM ? "ワンルーム" : value,
  value,
}));

export default FloorPlan;
